var React = require('react');

function IconLocation (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 13.5A3.75 3.75 0 1112 6a3.75 3.75 0 010 7.5zm0-6a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z","key":0}),React.createElement("path",{"d":"M12 22.5l-6.33-7.46-.26-.34a8.25 8.25 0 1113.18 0l-.26.34L12 22.5zm-5.4-8.7l.22.28 5.18 6.1 5.18-6.11.21-.28a6.75 6.75 0 10-10.78 0z","key":1})]);
}

IconLocation.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconLocation;

IconLocation.default = IconLocation;
